import $ from 'jquery';
import icon360 from 'url:../img/icons/360.svg';
import iconVideo from 'url:../img/icons/video.svg';
import iconImage from 'url:../img/icons/image.svg';
import { onClickAll, unsubscribeOnClickAll, onLongTouchAll, unsubscribeOnLongTouchAll } from './htmlListeners.js';
import * as selectItem from './itemSelectCounter.js';
import { isMobile, isIPhone } from './utils-module.js';
import * as emptyText from './emptyUserImageText.js';

const itemCssPath = '.gallery__item';
const getItemCssPathWithId = (id) => `${itemCssPath}[data-id="${id}"]`;
const galleryCssPath = '.gallery';
const smallActionPanelContainerInGallery = '.gallery__item-small-action-panel';
const sharePlaceInGallery = '.gallery__item-btn-share';
const classHiddenSmallActionPanelContainerInGallery = 'gallery__item-small-action-panel_hidden';
const classHiddenCheckboxPlaceInGallery = 'gallery__item-checkbox_hidden';
const classHiddenSharePlaceInGallery = 'gallery__item-btn-share_hidden';
const smallActionPanelDownloadBtnsInGallery = `${smallActionPanelContainerInGallery} .small-action-panel__download-btn`;
const shareBtnsInGallery = `${sharePlaceInGallery} .share-btn`;
const smallActionPanelFavoriteBtnsInGallery = `${smallActionPanelContainerInGallery} .small-action-panel__favorite-btn`;
const viewBtns = `.gallery__item-view`;
const classActivateSelection = 'gallery__item_active-select';
const classActivateMultiSelectionItem = 'gallery__item_active-multi-select-item';
const classActivateView = 'gallery__item_active-view';
const classActivateIconType = 'gallery__item_active-icon-type';
const classCheckedItem = 'gallery__item_checked';

function updateFavoriteState(id, isFavorite) {
  const $element = document.querySelector(getItemCssPathWithId(id));
  if (!$element) return;
  const $btn = $element.querySelector('.small-action-panel__favorite-btn');
  if (!$btn) return;
  $btn.classList.toggle('favorite-btn_active', isFavorite);
  $btn.setAttribute('title', isFavorite ? 'Unfavorite' : 'Favorite');
  const $icon = $btn.querySelector('i');
  if ($icon) {
    $icon.classList.toggle('fas', isFavorite);
    $icon.classList.toggle('far', !isFavorite);
  }
}

// galleryViewController
// Responsibilities render and clicks. Without logic!
// Only render model without logic
export function initGalleryViewController({
  isShowDownloadBtn = true,
  isShowShareBtn = true,
  isShowSelectItem = true,
  isShowFavoriteBtn = true,
  numberOfRows = 2,
} = {}) {
  let handlerOnClick = () => {};
  let handlerOnLongTouch = () => {};
  let handlerOnClickDownloadBtn = () => {};
  let handlerOnClickShareBtn = () => {};
  let handlerOnClickFavoriteBtn = () => {};
  let handlerOnClickViewBtn = () => {};
  let handlerOnClickIncrease = () => {};
  let handlerOnClickDecrease = () => {};
  const listenerOnClick = (event) => {
    event.preventDefault();
    handlerOnClick(getDataByEvent(event));
  };
  const listenerOnLongTouch = (event) => {
    event.preventDefault();
    handlerOnLongTouch(getDataByEvent(event));
  };
  const listenerOnClickDownloadBtn = (event) => {
    event.stopPropagation();
    handlerOnClickDownloadBtn(getDataByEvent(event));
  };
  const listenerOnClickShareBtn = (event) => {
    event.stopPropagation();
    handlerOnClickShareBtn(getDataByEvent(event));
  };
  const listenerOnClickFavoriteBtn = (event) => {
    event.stopPropagation();
    handlerOnClickFavoriteBtn(getDataByEvent(event));
  };
  const listenerOnClickView = (event) => {
    event.stopPropagation();
    handlerOnClickViewBtn(getDataByEvent(event));
  };

  setRow(numberOfRows);

  return {
    render,
    onClick,
    onLongTouch,

    select,
    unselect,
    unselectAll,
    enableSelect,
    disableSelect,

    showSelectItem: selectItem.show,
    hideSelectItem: selectItem.hide,
    enableMultiSelectItem,
    disableMultiSelectItem,
    onClickIncrease,
    onClickDecrease,
    updateCounter,

    onClickDownloadBtn,
    onClickShareBtn,
    onClickFavoriteBtn,

    enableView,
    disableView,
    onClickView,

    enableIconType,
    updateFavoriteState,
  };

  function setRow() {
    $(galleryCssPath).removeClass('gallery_row_1 gallery_row_2 gallery_row_3');
    if (numberOfRows === 1 || numberOfRows === 2 || numberOfRows === 3) {
      $(galleryCssPath).addClass(`gallery_row_${numberOfRows}`);
    }
  }

  function getDataByEvent(event) {
    return {
      id: Number(event.currentTarget.dataset.id),
      type: event.currentTarget.dataset.type,
    };
  }

  function render(items, emptyAlbumText) {
    if (items.length === 0) {
      $(galleryCssPath).hide();
      emptyText.setText(emptyAlbumText);
      emptyText.show();
      $(galleryCssPath).html();
      unsubscribe(items);
    } else {
      const htmlImages = items.map(renderItem).reduce((acc, str) => acc + str, '');
      emptyText.hide();
      $(galleryCssPath).html(htmlImages);
      $(galleryCssPath).show();
      subscribe(items);
    }
  }

  function dataAttributes({ id, type }) {
    return `data-id="${id}" data-type="${type}"`;
  }

  function isShowIcon({ type }) {
    if (isMobile()) return type === '360' || type === 'video';
    return true;
  }

  function getIconSrc({ type }) {
    if (type === '360') return icon360;
    if (type === 'video') return iconVideo;
    return iconImage;
  }

  function renderItem(item) {
    return `
        <div class="gallery__item" ${dataAttributes(item)}>
           <img class="gallery__item-img" src="${item.src}" alt="image"
                onerror="this.parentElement.style.display='none';"
            />
           ${renderWatermark(item.watermarkSrc)}
           <div class="gallery__item-checkbox ${item.canSelect ? '' : classHiddenCheckboxPlaceInGallery}">
               <img class="gallery__item-checkbox-img-checked" src="img/icons/checkbox-checked.svg" alt="checked" />
               <img class="gallery__item-checkbox-img-unchecked" src="img/icons/checkbox-unchecked.svg" alt="unchecked" />
           </div>
           ${renderIcon(item)}
           ${
             !isMobile() || item.type === 'video' || item.type === '360'
               ? `<img class="gallery__item-view" ${dataAttributes(item)} src="${getIconSrc(
                   item
                 )}" alt="" style="display:block;"/>`
               : ''
           }
           <div class="gallery__item-multi-select-item">
               ${selectItem.render({ id: item.id, isShow: isShowSelectItem })}
           </div>
          <div class="gallery__item-small-action-panel ${
            (isShowFavoriteBtn && item.canFavorite) || (isShowDownloadBtn && item.canDownload)
              ? ''
              : classHiddenSmallActionPanelContainerInGallery
           }">
              ${renderSmallActionPanel(item)}
           </div>
           <div class="gallery__item-btn-share ${
             isShowShareBtn && item.canShare ? '' : classHiddenSharePlaceInGallery
           }">
               <div class="share-btn" ${dataAttributes(item)}>
                   <img class="share-icon" src="img/icons/icon-share-white.svg" alt="share icon" />
                   <div class="share-btn__text">share</div>
               </div>
           </div>
       </div>
      `;
  }

  function renderWatermark(src) {
    if (src) {
      return `<div class="gallery__item-watermark" style="background-image:url('${src}')"></div>`;
    }
    return '';
  }

  function renderSmallActionPanel(item) {
    const canShowFavoriteBtn = isShowFavoriteBtn && item.canFavorite;
    const canShowDownloadBtn = isShowDownloadBtn && item.canDownload;
    if (!canShowFavoriteBtn && !canShowDownloadBtn) return '';

    const activeClass = item.isFavorite ? 'favorite-btn_active' : '';
    const iconClass = item.isFavorite ? 'fas' : 'far';
    const title = item.isFavorite ? 'Unfavorite' : 'Favorite';

    return `
      <div class="small-action-panel">
        ${
          canShowFavoriteBtn
            ? `<div class="favorite-btn small-action-panel__favorite-btn ${activeClass}" ${dataAttributes(
                item
              )} title="${title}">
                 <i class="${iconClass} fa-heart"></i>
               </div>`
            : ''
        }
        ${
          canShowFavoriteBtn && canShowDownloadBtn
            ? '<span class="small-action-panel__divider" aria-hidden="true"></span>'
            : ''
        }
        ${
          canShowDownloadBtn
            ? `<div class="small-action-panel__download-btn" ${dataAttributes(item)}>
                 <img class="download-icon small-action-panel__icon" src="img/icons/icon-download.svg" alt="download icon" />
               </div>`
            : ''
        }
      </div>
    `;
  }

  function renderIcon(item) {
    if (!isShowIcon(item)) return '';
    return `<img class="gallery__item-icon-type" src="${getIconSrc(item)}" alt="icon" />`;
  }

  function subscribe(items) {
    onClickAll(itemCssPath, listenerOnClick);
    onLongTouchAll(itemCssPath, listenerOnLongTouch);
    onClickAll(smallActionPanelDownloadBtnsInGallery, listenerOnClickDownloadBtn);
    onClickAll(shareBtnsInGallery, listenerOnClickShareBtn);
    onClickAll(smallActionPanelFavoriteBtnsInGallery, listenerOnClickFavoriteBtn);
    onClickAll(viewBtns, listenerOnClickView);
    items.forEach((item) => {
      selectItem.onClickPlus(item.id, handlerOnClickIncrease);
      selectItem.onClickMinus(item.id, handlerOnClickDecrease);
    });
  }

  function unsubscribe() {
    unsubscribeOnClickAll(itemCssPath, listenerOnClick);
    unsubscribeOnLongTouchAll(itemCssPath, listenerOnLongTouch);
    unsubscribeOnClickAll(smallActionPanelDownloadBtnsInGallery, listenerOnClickDownloadBtn);
    unsubscribeOnClickAll(shareBtnsInGallery, listenerOnClickShareBtn);
    unsubscribeOnClickAll(smallActionPanelFavoriteBtnsInGallery, listenerOnClickFavoriteBtn);
    unsubscribeOnClickAll(viewBtns, listenerOnClickView);
  }

  function onClick(cb) {
    handlerOnClick = cb;
  }

  function onLongTouch(cb) {
    handlerOnLongTouch = cb;
  }

  function onClickIncrease(cb) {
    handlerOnClickIncrease = cb;
  }

  function onClickDecrease(cb) {
    handlerOnClickDecrease = cb;
  }

  function updateCounter(id, count) {
    selectItem.updateAmount(id, count);
  }

  function select(id) {
    const $element = document.querySelector(getItemCssPathWithId(id));
    $element.classList.add(classCheckedItem);
  }

  function unselect(id) {
    const $element = document.querySelector(getItemCssPathWithId(id));
    $element.classList.remove(classCheckedItem);
  }

  function unselectAll() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.remove(classCheckedItem);
    });
  }

  function enableSelect() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.add(classActivateSelection);
    });
  }

  function disableSelect() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.remove(classActivateSelection);
    });
  }

  function enableMultiSelectItem() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.add(classActivateMultiSelectionItem);
    });
  }

  function disableMultiSelectItem() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.remove(classActivateMultiSelectionItem);
    });
  }

  function enableView() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.add(classActivateView);
    });
  }

  function disableView() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.remove(classActivateView);
    });
  }

  function enableIconType() {
    const $elements = document.querySelectorAll(itemCssPath);
    Array.from($elements).forEach(($element) => {
      $element.classList.add(classActivateIconType);
    });
  }

  function onClickDownloadBtn(cb) {
    handlerOnClickDownloadBtn = cb;
  }

  function onClickShareBtn(cb) {
    handlerOnClickShareBtn = cb;
  }

  function onClickFavoriteBtn(cb) {
    handlerOnClickFavoriteBtn = cb;
  }

  function onClickView(cb) {
    handlerOnClickViewBtn = cb;
  }

}
